import React from "react";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

const ORANGE = "#fb4d24";

function HomepageTrendingSlots(props) {
  const {
    items, isPublished, publishedAt, dirty, isSaving, maxItems,
    openPicker, setItems, save, publish, revert,
  } = props;

  const move = (from, to) => {
    if (to < 0 || to >= items.length) return;
    const next = items.slice();
    const [m] = next.splice(from, 1);
    next.splice(to, 0, m);
    setItems(next);
  };

  const remove = (idx) => {
    const next = items.slice();
    next.splice(idx, 1);
    setItems(next);
  };

  const full = items.length === maxItems;

  return (
    <GridContainer>
      <GridItem xs={12} md={12}>
        <div style={{ margin: "20px 4.5%", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h4 style={{ margin: 0, color: "#232323" }}>Homepage Trending&nbsp;</h4>
            <Chip
              label={isPublished ? "LIVE" : "Not live"}
              style={{ backgroundColor: isPublished ? "#24c32a" : "#8d8d8d", color: "#fff", height: 24, fontSize: 12 }}
            />
            {dirty ? <span style={{ color: ORANGE, marginLeft: 10, fontSize: 13 }}>unsaved changes</span> : null}
          </div>
          <div>
            <Button onClick={save} disabled={isSaving || items.length === 0} style={{ marginRight: 8 }}>
              {isSaving ? "Saving..." : "Save draft"}
            </Button>
            <Button
              onClick={publish}
              disabled={!full || dirty}
              variant="contained"
              style={{ backgroundColor: (!full || dirty) ? "#cccccc" : ORANGE, color: "#fff", marginRight: 8 }}
              title={!full ? "Pick exactly 5 articles" : dirty ? "Save the draft first" : ""}
            >
              Publish
            </Button>
            <Button onClick={revert} disabled={!isPublished} style={{ color: "#e53935" }}>
              Revert to automatic
            </Button>
          </div>
        </div>
      </GridItem>

      <GridItem xs={12} md={12}>
        <div style={{ margin: "0 4.5%" }}>
          {publishedAt && isPublished ? (
            <div style={{ color: "#8d8d8d", fontSize: 12, marginBottom: 8 }}>
              Published: {new Date(publishedAt).toLocaleString()}
            </div>
          ) : null}

          {items.map((it, idx) => (
            <Paper key={it.articleId} style={{ display: "flex", alignItems: "center", padding: 10, marginBottom: 10 }}>
              <div style={{ width: 28, fontWeight: "bold", color: ORANGE, textAlign: "center" }}>{idx + 1}</div>
              <a
                href={it.url || "#"}
                target="_blank"
                rel="noopener noreferrer"
                title={it.url ? "Open article in a new tab" : ""}
                style={{ display: "flex", alignItems: "center", flex: 1, overflow: "hidden", textDecoration: "none", color: "inherit", cursor: it.url ? "pointer" : "default" }}
              >
                <img src={it.thumbnail || ""} alt="" style={{ width: 96, height: 54, objectFit: "cover", borderRadius: 4, background: "#eeeeee" }} />
                <div style={{ flex: 1, padding: "0 12px", overflow: "hidden" }}>
                  <div style={{ fontWeight: 600, color: "#232323", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{it.title}</div>
                  <div style={{ color: "#8d8d8d", fontSize: 12, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>/{it.articleName}</div>
                </div>
              </a>
              <IconButton size="small" onClick={() => move(idx, idx - 1)} disabled={idx === 0}><ArrowUpwardIcon fontSize="small" /></IconButton>
              <IconButton size="small" onClick={() => move(idx, idx + 1)} disabled={idx === items.length - 1}><ArrowDownwardIcon fontSize="small" /></IconButton>
              <Button size="small" onClick={() => openPicker(idx)} style={{ color: ORANGE }}>Replace</Button>
              <IconButton size="small" onClick={() => remove(idx)} style={{ color: "#e53935" }}><DeleteIcon fontSize="small" /></IconButton>
            </Paper>
          ))}

          {items.length < maxItems ? (
            <div
              onClick={() => openPicker(items.length)}
              style={{ display: "flex", alignItems: "center", cursor: "pointer", color: ORANGE, padding: 14, border: "1px dashed #e7a08c", borderRadius: 4 }}
            >
              <AddCircleIcon />&nbsp;<span style={{ color: "#232323" }}>Add article ({items.length}/{maxItems})</span>
            </div>
          ) : null}
        </div>
        <div style={{ margin: "10px 4.5%", color: "#8d8d8d", fontSize: 13 }}>
          Exactly {maxItems} articles are required to publish. Publishing replaces the automatic (pageview-ranked) hero on the homepage until you revert.
        </div>
      </GridItem>
    </GridContainer>
  );
}

export default HomepageTrendingSlots;
